import { render, staticRenderFns } from "./EntryForm.vue?vue&type=template&id=b4385bfc&"
import script from "./EntryForm.vue?vue&type=script&lang=js&"
export * from "./EntryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports